<template>
  <v-card v-for="account in currentAccounts" :key="account.server">
    <v-card-title>{{ account.server }}</v-card-title>
    <v-card-text
      ><v-list>
        <v-list-item
          v-for="repo in account.repositories"
          :key="repo.owner + '/' + repo.repository"
          :title="repo.owner + '/' + repo.repository"
          @click="to(account.server, repo.owner, repo.repository)"
        ></v-list-item></v-list
    ></v-card-text>
  </v-card>
</template>
<script setup lang="ts">
import { useRouter } from "vue-router";
import { currentAccounts, setActiveAccount } from "../authenticationTokens";

const router = useRouter();

function to(server: string, owner: string, repo: string) {
  setActiveAccount(server);
  void router.push({
    name: "/repos/[owner]/[repo]/",
    params: {
      owner,
      repo,
    },
  });
}
</script>
